<sc-flex vertical fitHeight stretchContent>
  <sc-dialog-title>
    <sc-dictionary-label dictionaryKey="tmc-yard.ui.edit-transport.transport.edit.title"></sc-dictionary-label>
  </sc-dialog-title>
  <sc-flex-fitting-content vertical>
    <sc-padding fitHeight>
      @if (editTransport != null && editTransport.transport != null) {
        <mat-tab-group style="height: 100%;">
          <mat-tab
            label="{{'protocoll' | translate: ['tmc-yard.ui.edit-transport.transport.edit.tab.masterdata', translationService.language, translationService.revision]}}">
            <sc-scroll-pane>
              <sc-content-spacer vertical></sc-content-spacer>
              <app-transport-details [mode]="TransportDetailMode.EDITING" [transport]="editTransport.transport"
                [layout]="layout">
              </app-transport-details>
            </sc-scroll-pane>
          </mat-tab>
          <mat-tab
            label="{{'protocoll' | translate: ['tmc-yard.entity.transport.options', translationService.language, translationService.revision]}}">
            <sc-scroll-pane>
              <sc-content-spacer vertical></sc-content-spacer>
              <div class="tab-content">
                <app-transport-options-panel [model]="model"></app-transport-options-panel>
                  <div class="form-box"
                    >
                    <sc-content-spacer vertical double></sc-content-spacer>
                    <mat-checkbox class="options-checkbox" [(ngModel)]="editTransport.restartRouting"
                      [disabled]="!editTransport.restartRoutingPossible || !this.editTransport.optionsChanged">
                      <sc-dictionary-label dictionaryKey="tmc-yard.ui.edit-transport.transport.edit.restartRouting"></sc-dictionary-label>
                    </mat-checkbox>
                  </div>
              </div>
            </sc-scroll-pane>
          </mat-tab>
        </mat-tab-group>
      }
    </sc-padding>
  </sc-flex-fitting-content>
  <app-service-response [responseMessages]="responseMessages"></app-service-response>
  <sc-padding>
    <div [formGroup]="formGroup">
      <sc-flex>
        <sc-content-spacer grow></sc-content-spacer>
        @if (editTransport?.inPlanningMode) {
          <sc-checkbox-field formControlName="registerArrival" labelDictionaryKey="tmc-yard.ui.transport-registration.checkbox.register-arrival"></sc-checkbox-field>
          <sc-content-spacer></sc-content-spacer>
          <sc-checkbox-field formControlName="registerEntrance" labelDictionaryKey="tmc-yard.ui.edit-transport.transport.edit.registerEntrance">
          </sc-checkbox-field>
          <sc-content-spacer grow></sc-content-spacer>
        }
        <sc-cancel-button (click)="cancel()"></sc-cancel-button>
        <sc-content-spacer></sc-content-spacer>
        <sc-save-button primary (click)="save()" [disabled]="isSaveDisabled()"></sc-save-button>
      </sc-flex>
    </div>
  </sc-padding>
</sc-flex>
